;(function () {
  'use strict'

  angular
    .module('contrast.security-controls')
    .constant('SECURITY_CONTROL_TYPES', {
      INPUT_VALIDATOR: { value: 'INPUT_VALIDATOR', label: 'Input validator' },
      PATTERN_VALIDATOR: {
        value: 'PATTERN_VALIDATOR',
        label: 'Regex validator'
      },
      SANITIZER: { value: 'SANITIZER', label: 'Sanitizer' }
    })
})()
